import{__require as r}from"./is-object.js";var e,t;function n(){if(t)return e;t=1;var n=r(),i=String,o=TypeError;return e=function(r){if(n(r))return r;throw new o(i(r)+" is not an object")}}export{n as __require};
//# sourceMappingURL=an-object.js.map
